const showLocationPopup = () => {
	Swal.fire({
      html: `<a
  href="https://bliss-tree.us"
  class="countries_name"
  >Rest Of USA</a
>
<a
  href="https://bliss-tree-nj.us"
  class="countries_name"
  >New Jersey</a
>
<a
  href="https://bliss-tree-ct.us"
  class="countries_name"
  >Connecticut</a
>
<a
  href="https://bliss-tree-mi.us"
  class="countries_name"
  >Michigan</a
>
<a
  href="https://bliss-tree-il.us"
  class="countries_name"
  >Illinois</a
>`,
      showCloseButton: true,
      showConfirmButton: false,
      focusCancel: false,
      width: "18rem",
      customClass: {
        header: "location-swal-header"
      }
    });
}